import { SxProps, Theme } from '@mui/material'

export const indexComponentRowCellDividerSx: SxProps<Theme> = {
    borderBottom: 1,
    borderColor: 'divider',
}

export const indexComponentBodyCellSx: SxProps<Theme> = {
    py: 0.5,
    px: 1,
    ...indexComponentRowCellDividerSx,
}
